"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MobileAppIcon = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = _interopRequireDefault(require("react"));
var _utils = require("../../../../utils");
var _constants = require("./constants");
var _jsxRuntime = require("react/jsx-runtime");
const MobileAppIcon = ({
  title,
  titleImage
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const theme = (0, _mui.useTheme)();
  if (!titleImage) {
    return null;
  }
  const isGifOrSvg = titleImage.toLowerCase().includes('inputformat=gif') || titleImage.toLowerCase().includes('inputformat=svg');
  if (isGifOrSvg) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
      "data-testid": getTestId(_constants.MOBILE_APP_ICON_GIF_OR_SVG),
      alt: title,
      loading: "lazy",
      src: titleImage,
      width: _constants.MOBILE_APP_ICON_WIDTH,
      height: _constants.MOBILE_APP_ICON_HEIGHT
    });
  }
  const imageData = {
    url: titleImage,
    passPNG: false,
    jpgSettings: ['h=120', 'q=90', `ib=${encodeURIComponent(theme.palette.grey[100])}`]
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
    "data-testid": getTestId(_constants.MOBILE_APP_ICON),
    alt: title,
    loading: "lazy",
    src: (0, _utils.updateImageUrl)(imageData),
    width: _constants.MOBILE_APP_ICON_WIDTH,
    height: _constants.MOBILE_APP_ICON_HEIGHT
  });
};
exports.MobileAppIcon = MobileAppIcon;